export const HEADER = "المعاملات الخاصة بك";
export const BRIEF = "يمكنك الإطلاع على كل معاملاتك وتتبع حالتها أولا بأول.";
export const ACTIVE_CONTRACTS_TAB = "المعاملات النشطة";
export const PREVIOUS_CONTRACTS_TAB = "المعاملات السابقة";

export const BUTTON = {
  SEARCH: "البحث عن طريق رمز المعاملة",
  ALL_CASES: "جميع الحالات",
  START_DATE: "تاريخ البدء",
  END_DATE: "تاريخ الانتهاء",
};
